import React, { FunctionComponent, ReactNode } from 'react'
import styles from './style.module.scss'

export interface RadioHeaderProps {
  children: ReactNode
  testNameSpace?: string
}

export const RadioHeader: FunctionComponent<RadioHeaderProps> = ({ children, testNameSpace = '' }) => {
  return (
    <div className={styles.header} {...(testNameSpace.length > 0 && { 'data-testid': `${testNameSpace}-radio-header` })}>
      {children}
    </div>
  )
}
